var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"subGlobal",staticClass:"global-main global-shadow"},[_c('div',{directives:[{name:"loading",rawName:"v-loading.body",value:(_vm.loading.main),expression:"loading.main",modifiers:{"body":true}}],staticClass:"global-panel"},[_vm._v("\r\n  正在跳转，请稍后\r\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b1fc2de","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/DispatchHome.vue
// module id = aMCs
// module chunks = 0